import _get from 'lodash/get';

const selectRegisteredFields = state => _get(state, 'form.carsSearchForm.registeredFields', {});

export default selectRegisteredFields;
